module.exports = __webpack_public_path__ + "static/media/search.53b94018.svg";